import { render, staticRenderFns } from "./EnvironmentPage.vue?vue&type=template&id=1ffe55c8&scoped=true&"
import script from "./EnvironmentPage.vue?vue&type=script&lang=js&"
export * from "./EnvironmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffe55c8",
  null
  
)

export default component.exports